var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"onboarding-status",style:(_vm.style)},[_c('span',{staticClass:"onboarding-status__label"},[_vm._v(_vm._s(_vm.statusLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }